import React, { useState, useEffect } from 'react';
import { Modal, View, Text, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { colores, fuentes, fontSizes, spacing } from '../../styles/variablesCss';
import { globalStyles } from '../../styles/globalStyles';
import { useNavigation } from '@react-navigation/native';
import { getEnvioGratisInfo } from '../../Config/Const';
import { formatPrecio } from '../../utils/formatPrice';

const ModaleFleteGratis = ({ visible, onClose, total = 0, subtotal = null }) => {
  const navigation = useNavigation();
  
  // Estado para controlar responsividad
  const [windowWidth, setWindowWidth] = useState(
    Platform.OS === 'web' && typeof window !== 'undefined' ? window.innerWidth : 768
  );
  const isMobile = windowWidth < 768;

  // Listener para cambios de tamaño de ventana
  useEffect(() => {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
      
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);

  // Bloquear scroll del body cuando el modal está visible y scroll automático arriba
  useEffect(() => {
    if (Platform.OS === 'web' && typeof document !== 'undefined') {
      if (visible) {
        // Guardar posición del scroll antes de bloquear
        const scrollY = window.scrollY;
        
        // Scroll instantáneo hacia arriba
        window.scrollTo(0, 0);
        
        // Bloquear scroll inmediatamente
        document.body.style.position = 'fixed';
        document.body.style.top = '0px';
        document.body.style.left = '0px';
        document.body.style.right = '0px';
        document.body.style.width = '100%';
        document.body.style.height = '100vh';
        document.body.style.overflow = 'hidden';
        
        // Prevenir bounce en iOS y bloquear overscroll
        document.body.style.webkitOverflowScrolling = 'touch';
        document.body.style.overscrollBehavior = 'none';
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.style.overscrollBehavior = 'none';
        
        // Prevenir scroll mediante eventos
        const preventScroll = (e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        };
        
        const preventTouchMove = (e) => {
          // Permitir scroll dentro del contenido del modal
          const modalContent = e.target.closest('[data-modal-content="true"]');
          if (modalContent) {
            return true;
          }
          
          // Prevenir scroll en el overlay o body
          if (e.target === document.body || e.target.closest('.modal-overlay-flete')) {
            e.preventDefault();
            return false;
          }
        };
        
        // Agregar listeners para prevenir scroll
        window.addEventListener('scroll', preventScroll, { passive: false });
        window.addEventListener('wheel', preventScroll, { passive: false });
        window.addEventListener('touchmove', preventTouchMove, { passive: false });
        document.addEventListener('touchmove', preventTouchMove, { passive: false });
        
        return () => {
          // Remover event listeners
          window.removeEventListener('scroll', preventScroll);
          window.removeEventListener('wheel', preventScroll);
          window.removeEventListener('touchmove', preventTouchMove);
          document.removeEventListener('touchmove', preventTouchMove);
          
          // Restaurar estilos
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.left = '';
          document.body.style.right = '';
          document.body.style.width = '';
          document.body.style.height = '';
          document.body.style.overflow = '';
          document.body.style.webkitOverflowScrolling = '';
          document.body.style.overscrollBehavior = '';
          document.documentElement.style.overflow = '';
          document.documentElement.style.overscrollBehavior = '';
          
          // Volver a la posición original del scroll
          window.scrollTo(0, scrollY);
        };
      }
    }
  }, [visible]);
  
  const { montoMinimoEnvioGratis, montoFaltante, montoFaltanteFormateado } = getEnvioGratisInfo({ total, subtotal });
  const montoMinimoEnvioGratisFormateado = formatPrecio(Math.round(Number(montoMinimoEnvioGratis) || 0));
  
  // Estilos dinámicos
  const dynamicStyles = {
    modalView: {
      ...styles.modalView,
      width: isMobile ? '95%' : (Platform.OS === 'web' ? '80%' : '90%'),
      height: isMobile ? 'auto' : 350,
      padding: isMobile ? 15 : 60,
      paddingTop: isMobile ? 20 : 35,
      paddingBottom: isMobile ? 60 : 70,
      marginTop: isMobile ? 50 : 10,
    },
    contentContainer: {
      ...styles.contentContainer,
      //marginLeft: isMobile ? 0 : 100,
      flexDirection: 'column',
      alignItems: isMobile ? 'center' : 'flex-end',
      justifyContent: 'flex-start',
    },
    textsContainer: {
      width: '100%',
      flex: 1,
      alignItems: isMobile ? 'center' : 'flex-end',
    },
    modalTitle: {
      ...styles.modalTitle,
      fontSize: isMobile ? 22 : 32,
      textAlign: isMobile ? 'center' : 'right',
    },
    montoFaltanteText: {
      ...styles.montoFaltanteText,
      fontSize: isMobile ? 12 : 16,
      textAlign: isMobile ? 'center' : 'right',
    },
    seguirComprandoButton: {
      ...styles.seguirComprandoButton,
      maxWidth: isMobile ? '100%' : 300,
      //marginRight: isMobile ? 0 : 60,
      alignSelf: isMobile ? 'center' : 'flex-end',
    },
    volverButton: {
      ...styles.volverButton,
      marginLeft: isMobile ? spacing.sm : spacing.lg,
    },
  };
  
  return (
    Platform.OS === 'web' ? (
      // En web, renderizar directamente sin usar Modal de React Native
      visible && (
        <View 
          style={styles.centeredView}
          className="modal-overlay-flete"
          nativeID="modal-overlay-flete"
          onClick={(e) => {
            // Cerrar si se hace clic en el overlay (no en el contenido)
            if (e.target === e.currentTarget) {
              onClose();
            }
          }}
        >
          <View 
            style={dynamicStyles.modalView}
            {...(Platform.OS === 'web' ? { 'data-modal-content': 'true' } : {})}
            nativeID="modal-content-flete"
          >
          {/* Botón de cerrar X */}
          <TouchableOpacity 
            style={styles.closeButton}
            onPress={onClose}
          >
            <MaterialCommunityIcons name="close" size={24} color={colores.grisOscuro} />
          </TouchableOpacity>

          <View style={dynamicStyles.contentContainer}>
            <View style={dynamicStyles.textsContainer}>
              {/* Título principal en rojo */}
              <Text style={[globalStyles.title, dynamicStyles.modalTitle, { fontWeight: 'bold' }]}>ENVÍO GRATIS DESDE ${montoMinimoEnvioGratisFormateado}</Text>
              {/* Texto dinámico que muestra cuánto falta para obtener el beneficio */}
              <Text style={[globalStyles.text, dynamicStyles.montoFaltanteText]}>
                {montoFaltante > 0 
                  ? `¡Te faltan $${montoFaltanteFormateado} para obtener el beneficio!` 
                  : "¡Felicidades! Ya tienes envío gratis en tu compra"}
              </Text>
            </View>
            {/* Botón CONTINUAR CON EL PAGO (principal) */}
            <TouchableOpacity
              style={[globalStyles.button, dynamicStyles.seguirComprandoButton]}
              onPress={() => {
                onClose();
              }}
            >
              <Text style={[globalStyles.buttonText, styles.seguirComprandoText]}>CONTINUAR CON EL PAGO</Text>
            </TouchableOpacity>
          </View>
          
          {/* Barra roja en la parte inferior */}
          <View style={styles.redBar}>
            {/* Botón SEGUIR COMPRANDO en la barra roja */}
            <TouchableOpacity 
              style={dynamicStyles.volverButton}
              onPress={() => {
                onClose();
                navigation.navigate('');
              }}
            >
              <MaterialCommunityIcons 
                name="arrow-left" 
                size={18} 
                color={colores.blanco} 
              />
              <Text style={[globalStyles.buttonText, styles.volverText]}>Seguir comprando</Text>
            </TouchableOpacity>
          </View>
        </View>
        </View>
      )
    ) : (
      // En móvil, usar Modal de React Native
      <Modal
        animationType="fade"
        transparent={true}
        visible={visible}
      >
        <View 
          style={styles.centeredView}
          className="modal-overlay-flete"
          nativeID="modal-overlay-flete"
        >
          <View 
            style={dynamicStyles.modalView}
            {...(Platform.OS === 'web' ? { 'data-modal-content': 'true' } : {})}
            nativeID="modal-content-flete"
          >
          {/* Botón de cerrar X */}
          <TouchableOpacity 
            style={styles.closeButton}
            onPress={onClose}
          >
            <MaterialCommunityIcons name="close" size={24} color={colores.grisOscuro} />
          </TouchableOpacity>

          <View style={dynamicStyles.contentContainer}>
            <View style={dynamicStyles.textsContainer}>
              {/* Título principal en rojo */}
              <Text style={[globalStyles.title, dynamicStyles.modalTitle]}>ENVÍO GRATIS DESDE ${montoMinimoEnvioGratisFormateado}</Text>
              {/* Texto dinámico que muestra cuánto falta para obtener el beneficio */}
              <Text style={[globalStyles.text, dynamicStyles.montoFaltanteText]}>
                {montoFaltante > 0 
                  ? `¡Te faltan $${montoFaltanteFormateado} para obtener el beneficio!` 
                  : "¡Felicidades! Ya tienes envío gratis en tu compra"}
              </Text>
            </View>
            {/* Botón CONTINUAR CON EL PAGO (principal) */}
            <TouchableOpacity
              style={[globalStyles.button, dynamicStyles.seguirComprandoButton]}
              onPress={() => {
                onClose();
              }}
            >
              <Text style={[globalStyles.buttonText, styles.seguirComprandoText]}>CONTINUAR CON EL PAGO</Text>
            </TouchableOpacity>
          </View>
          
          {/* Barra roja en la parte inferior */}
          <View style={styles.redBar}>
            {/* Botón SEGUIR COMPRANDO en la barra roja */}
            <TouchableOpacity 
              style={dynamicStyles.volverButton}
              onPress={() => {
                onClose();
                navigation.navigate('');
              }}
            >
              <MaterialCommunityIcons 
                name="arrow-left" 
                size={18} 
                color={colores.blanco} 
              />
              <Text style={[globalStyles.buttonText, styles.volverText]}>Seguir comprando</Text>
            </TouchableOpacity>
          </View>
          </View>
        </View>
      </Modal>
    )
  );
};

const styles = StyleSheet.create({
  centeredView: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    ...(Platform.OS === 'web' ? {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 999999,
      display: 'flex',
    } : {
      flex: 1,
    }),
  },
  modalView: {
    width: Platform.OS === 'web' ? '80%' : '90%',
    maxWidth: 650,
    height: 280,
    backgroundColor: colores.blanco,
    padding: 25,
    paddingTop: 35,
    paddingBottom: 70, // Increased to make space for the red bar
    position: 'relative',
    marginTop: 100,
    borderRadius: 5,
    overflow: 'hidden', // Ensures the red bar doesn't extend beyond the border radius
    flexDirection: 'column', // Elementos en columna
    alignItems: 'center',
    justifyContent: 'center',
    ...(Platform.OS === 'web' ? {
      zIndex: 1000000,
    } : {}),
  },
  contentContainer: {
    alignItems: 'flex-start', // Alinear contenido a la izquierda
    width: '100%',
  },
  modalTitle: {
    fontSize: 28, 
    color: colores.rojo,
    fontFamily: 'Montserrat-Bold',
    marginBottom: spacing.md,
    textAlign: 'left',
    width: '100%',
  },
  montoFaltanteText: {
    fontSize: 18,
    marginBottom: spacing.lg,
    textAlign: 'left',
    width: '100%',
  },
  seguirComprandoButton: {
    paddingVertical: spacing.sm * 1.5,
    paddingHorizontal: spacing.lg * 1.25,
    maxWidth: 250,
    alignItems: 'center',
    marginBottom: spacing.lg,
    //marginRight: 60,
    alignSelf: 'flex-end', // Alinear el botón a la derecha
  },
  seguirComprandoText: {
    textTransform: 'uppercase',
  },
  redBar: {
    backgroundColor: colores.rojo,
    width: '100%',
    height: 50,
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    justifyContent: 'center',
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
    alignItems: 'flex-start',
  },
  volverButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingVertical: spacing.sm - 3,
    marginLeft: spacing.lg,
  },
  volverText: {
    color: colores.blanco,
    marginLeft: spacing.sm - 3,
    fontSize: fontSizes.texto,
  },
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    zIndex: 10,
    padding: 5,
    ...(Platform.OS === 'web' ? {
      cursor: 'pointer',
    } : {}),
  },
});

export default ModaleFleteGratis;
